import React, {useEffect, useCallback} from 'react';
import {connect} from 'react-redux';
import {getImageUrlOrDefault, getTextOrDefault} from 'app/Components/Block/BusinessDashboardBlock/utils/functions';
import IvrCategory from 'app/Components/Block/VisualIVRMenuBlock/components/subComponents/IvrCategory/IvrCategory';
import {saveToHistory} from 'app/Components/Block/VisualIVRMenuBlock/VisualIVRSlice';
import {visualIvrSteps, visualIvrColors} from 'app/Components/Block/VisualIVRMenuBlock/utils/constants';

const VisualIvrMenu = ({context,contentData,saveToHistory}) => {

  const {title,subTitle,titlesColor,menuBackgroundImage,ivrCategoryList} = contentData || {};

  const titleStr = getTextOrDefault(title);
  const subTitleStr = getTextOrDefault(subTitle);

  useEffect(() => {
    saveToHistory(visualIvrSteps.MENU);
  }, []);

  const ivrMenuStyle = {
    backgroundImage: menuBackgroundImage ? `url(${getImageUrlOrDefault(menuBackgroundImage)})` : 'none',
    backgroundSize: 'cover',
    '--text-color': titlesColor?.value || visualIvrColors.BLACK,
  };

  return (
    <div className='visual-ivr-menu-container'>
      <div className='visual-ivr-menu' style={ivrMenuStyle}>
        {(titleStr || subTitleStr) && (
          <div className='titles-section'>
            {titleStr && <span className='title'>{titleStr}</span>}
            {subTitleStr && <span className='sub-title'>{subTitleStr}</span>}
          </div>
        )}
      </div>
      <div className='ivr-categories-section'>
        {ivrCategoryList?.value?.map((category, index) => (
          <IvrCategory key={index} category={category} />
        ))}
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({

});

const mapDispatchToProps = {
  saveToHistory,
};

export default connect(mapStateToProps, mapDispatchToProps)(VisualIvrMenu);
